import { Routes, Route } from 'react-router-dom';
import './styles/app.scss';

import MasterLayout from './layout/Master';

import Home from './pages/Home';
import Instruction from './pages/Instruction';
import DataEntry from './pages/DataEntry';
import DataEntryMobile from './pages/DataEntryMobile';
import Quiz from './pages/Quiz';
import Results from './pages/Results';
import Game from './pages/Game';
import KioskId from './components/KioskId';
import KioskIdMobile from './components/KioskIdMobile';

function App() {
  return (
    <MasterLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/instruction" element={<Instruction />} />
        <Route path="/data-entry" element={<DataEntry />} />
        <Route path="/data-entry-mobile" element={<DataEntryMobile />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/results" element={<Results />} />
        <Route path="/game" element={<Game />} />
        <Route path="/k/:kioskId" element={<KioskId />} />
        <Route path="/m/:kioskId" element={<KioskIdMobile />} />
      </Routes>
    </MasterLayout>
  );
}

export default App;
